import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useDebounce } from '../../utils/misc'
import closeIcon from '../../images/closeIcon.svg'
import searchIcon from '../../images/searchIcon.svg'

const Search = ({ input, placeholder = 'Szukaj', ...props }) => {
  const mounted = useRef(false) // to prevent from fire onMount
  const [value, onChange] = useState(input.value || '')

  const debouncedValue = useDebounce(value, 300)

  useEffect(
    () => {
      if (!mounted.current) {
        mounted.current = true
        return
      }
      input.onChange(debouncedValue)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedValue]
  )
  useEffect(() => void onChange(input.value), [input.value])

  return (
    <Wrapper>
      <SearchIcon alt="" aria-hidden="true" />
      <SearchInput
        placeholder={placeholder}
        aria-label={props.ariaLabel ? props.ariaLabel : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value.length > 0 && <ClearButton aria-label="Wyczyść" onClick={() => onChange('')}><CloseIcon alt="" aria-hidden="true" /></ClearButton>}
    </Wrapper>
  )
}

const Wrapper = styled.span`
  position: relative;
  ${({ width }) => width != null && `width: ${width}px`};
  ${(postModal) => (postModal ? `max-width:230px` : `max-width:330px`)};
  border: none;
  display: flex;
  ${(postModal) => (postModal ? `margin-right: 7px;` : `margin-right: 15px`)};
  flex: 1;
`

const SearchInput = styled.input`
  border: 1px solid #ddd;
  font-size: 14px;
  padding: 10px 25px 10px 40px;
  border-radius: 4px;
  height: 50px;
  box-sizing: border-box;
`
const SearchIcon = styled.img.attrs({
  src: searchIcon,
})`
  position: absolute;
  left: 10px;
  top: 14px;
`

const ClearButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
`

const CloseIcon = styled.img.attrs({
  src: closeIcon,
})`
  height: 14px;
  width: 14px;
  position: absolute;
  right: 10px;
  top: 17px;
`

export default Search
